export const STORAGE_KEY ={
    TOKEN:'token',
    MODEL_ID:'modelId',
    MODEL_NAME:"modelName",
    RECORD_PERMISSION:'recorder_permission',
    START_CHAT_TIME:"chatStartTime",
}


// WEBPACK FOOTER //
// ./src/utils/define.js